import React from "react"
import FieldView, {FieldViewProps} from "../../../render/view";

export default function FieldProjectPath_ViewProperty(props: FieldViewProps) {

    const classes = Classes("tiny-not-important", props.className);

    return (
        <FieldView field        = {props.field}
                   model        = {props.model}
                   params       = {{maxParents: props.field.maxParents}}
                   viewType     = "full-path"
                   className    = {classes}
        />
    )
}
